import { defineStyleConfig } from '@chakra-ui/system';

const baseStyle = {
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
};

export const Link = defineStyleConfig({
    variants: {
        base: baseStyle,
    },
});
